import { render, staticRenderFns } from "./paperAnalysis.vue?vue&type=template&id=c373eaa0&scoped=true&"
import script from "./paperAnalysis.vue?vue&type=script&lang=js&"
export * from "./paperAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./paperAnalysis.vue?vue&type=style&index=0&id=c373eaa0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c373eaa0",
  null
  
)

export default component.exports